"use strict";

var _interopRequireDefault = require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _toConsumableArray2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/web.dom.iterable");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
var _path = _interopRequireDefault(require("path"));
var _utils = require("@/utils");
var _systems = require("@/api/systems");
var _systems2 = require("../../api/systems");
var _timers = require("timers");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { getRoutes, addRole, deleteRole, updateRole } from '@/api/role'

// import i18n from '@/lang'

var defaultRole = {
  key: "",
  // name: '',
  description: "",
  routes: []
};
var _default = exports.default = {
  name: 'RolePermission',
  inject: ["reload"],
  data: function data() {
    return {
      roleList: [],
      isDisable: false,
      value: "",
      role: {},
      routes: [],
      dialogVisible: false,
      dialogFormVisible: false,
      dialogType: "new",
      checkStrictly: false,
      loading: false,
      isRepeat: false,
      defaultProps: {
        id: "id",
        children: "children",
        label: "label"
      },
      saveid: "",
      rolesLists: [],
      exchange: false,
      param: {
        pageNo: 1,
        pageSize: 10,
        roleName: "",
        sortField: "",
        sortRules: ""
      },
      form: {
        name: "",
        remark: "",
        pid: ""
      },
      routesData: [],
      options: [],
      formLabelWidth: "100px",
      arr: [],
      addarr: [],
      arr1: [],
      arr2: [],
      total: 0,
      currentPage: 1,
      //授权
      dialogFormsVisible: false,
      idList: [],
      idList2: [],
      keepid: "",
      changeId: ""
    };
  },
  computed: {
    // routesData() {
    //   return this.routes;
    // }
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.loading = true;
      (0, _timers.setTimeout)(function () {
        (0, _systems.getRole)(_this.param).then(function (res) {
          _this.rolesLists = res.voList;
          _this.total = res.total;
          _this.loading = false;
          _this.isRepeat = false;
        });
      }, 500);
    },
    getSub: function getSub() {
      var _this2 = this;
      (0, _systems.getList)(this.role.pid).then(function (res) {
        _this2.routesData = res.map(function (item) {
          item.label = item.label;
          return item;
        });
      });
    },
    //分页
    changepage: function changepage(currentPage) {
      this.currentPage = currentPage;
      this.param.pageNo = currentPage;
      this.getList();
    },
    //查询角色
    search: function search() {
      this.getList();
    },
    //清空
    empty: function empty() {
      this.param.roleName = "";
      this.getList();
    },
    //关闭事件
    close: function close() {
      this.role = {};
      // this.routesData = ''
      this.dialogVisible = false;
      this.dialogFormVisible = false;
      this.dialogFormsVisible = false;
      this.form.name = "";
      this.form.remark = "";
      this.idList = [];
      this.reload();
    },
    getChecked: function getChecked(val) {
      this.arr1 = this.$refs.tree.getCheckedKeys();
      // this.arr1.shift()
      var c = [];
      this.arr1.map(function (res) {
        if (isNaN(Number(res))) {
          c.push(res);
        }
      });
      this.arr2 = this.$refs.tree.getHalfCheckedKeys();
      var arr6 = [];
      this.arr2.map(function (res, idx) {
        if (res) {
          if (idx !== 0) {
            arr6.push(res);
          }
        }
      });
      this.arr = c.concat(arr6);
    },
    //修改
    change: function change(v) {
      var _this3 = this;
      this.isDisable = false;

      // querySelectResource(v.id).then(res => {
      //   this.routesData = res.map(item => {
      //     item.name = item.name;
      //     return item;
      //   });
      // });
      (0, _systems.queryRole)().then(function (res) {
        _this3.roleList = res.voList;
      });
      v.resourceVOList.map(function (res) {
        _this3.arr.push(res.id);
      });
      (0, _systems.idUser)(v.id).then(function (res) {
        res.resourceVOList.map(function (res) {
          res.children.map(function (item) {
            item.children.map(function (result) {
              if (result.children.length > 0) {
                result.children.map(function (res) {
                  _this3.idList.push(res.id);
                });
              } else {
                _this3.idList.push(result.id);
              }
            });
          });
        });
        _this3.form.name = res.name;
        _this3.form.remark = res.remark;
        _this3.form.pid = res.pid;
        (0, _systems.querySelectResource)(res.pid).then(function (res) {
          _this3.routesData = res.map(function (item) {
            item.label = item.label;
            return item;
          });
        });
      });
      (0, _timers.setTimeout)(function () {
        _this3.dialogFormVisible = true;
      }, 500);
      this.saveid = v.id;
    },
    sure: function sure() {
      var _this4 = this;
      if (this.form.name == "" || this.form.name == null) {
        this.$message({
          type: "warning",
          message: "请填写角色名称",
          center: true
        });
        return;
      }
      var getCheck = this.$refs.tree.getCheckedKeys();
      if (getCheck == "" || getCheck == null) {
        this.$message({
          type: "error",
          message: "角色至少拥有一条权限",
          center: true
        });
        return;
      }
      this.isRepeat = true;
      this.isDisable = true;
      //去掉集合里面的空
      for (var i = 0; i < this.arr.length; i++) {
        if (this.arr[i] == " " || this.arr[i] == null || typeof this.arr[i] == "undefined") {
          this.arr.splice(i, 1);
          i = i - 1;
        }
      }
      (0, _systems.amendUser)(this.saveid, {
        idList: this.arr,
        name: this.form.name,
        remark: this.form.remark,
        pid: this.form.pid
      }).then(function (res) {
        if (res.success) {
          _this4.$message({
            type: "success",
            message: "修改成功",
            center: true
          });
          _this4.reload();
          _this4.dialogFormVisible = false;
          // this.getList();
          _this4.idList = [];
          _this4.arr = [];
        } else {
          _this4.$message({
            type: "error",
            message: res.errorMsg,
            center: true
          });
          _this4.isRepeat = false;
          _this4.isDisable = false;
        }
      });
    },
    accreditCheck: function accreditCheck() {
      this.arr1 = this.$refs.accreditTree.getCheckedKeys();
      // this.arr1.shift()
      var b = [];
      this.arr1.map(function (res) {
        if (isNaN(Number(res))) {
          b.push(res);
        }
      });
      this.arr2 = this.$refs.accreditTree.getHalfCheckedKeys();
      var arr5 = [];
      this.arr2.map(function (res, idx) {
        if (idx !== 0) {
          arr5.push(res);
        }
      });
      this.arr = b.concat(arr5);
    },
    //授权
    accredit: function accredit(v) {
      var _this5 = this;
      this.dialogFormsVisible = true;
      this.isDisable = false;
      (0, _systems.getList)(v.id).then(function (res) {
        _this5.routesData = res.map(function (item) {
          item.label = item.label;
          return item;
        });
      });
      (0, _systems.queryRole)().then(function (res) {
        _this5.roleList = res.voList;
      });
      v.resourceVOList.map(function (res) {
        _this5.arr.push(res.id);
      });
      var arr = [];
      (0, _systems.idUser)(v.id).then(function (res) {
        arr = res.resourceVOList;
        _this5.form.pid = res.pid;
      });
      arr && arr.map(function (res) {
        _this5.idList2.push(res.id);
      });
      console.log("2", this.idList2);
      this.keepid = v.id;
    },
    keep: function keep() {
      var _this6 = this;
      var getCheck = this.$refs.accreditTree.getCheckedKeys();
      if (getCheck == "" || getCheck == null) {
        this.$message({
          type: "error",
          message: "角色至少拥有一条权限",
          center: true
        });
        return;
      }
      this.isRepeat = true;
      this.isDisable = true;
      (0, _systems.authorUser)(this.keepid, {
        idList: this.arr
      }).then(function (res) {
        if (res.success) {
          _this6.$message({
            type: "success",
            message: "授权成功",
            center: true
          });
          _this6.dialogFormsVisible = false;
          // this.getList();
          _this6.reload();
          // this.idList = [];
          // this.arr = [];
        } else {
          _this6.$message({
            type: "error",
            message: res.errorMsg,
            center: true
          });
          _this6.isRepeat = false;
          _this6.isDisable = false;
        }
      });
    },
    //删除
    dele: function dele(v) {
      var _this7 = this;
      this.$confirm("您是否要删除当前选中的记录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this7.isRepeat = true;
        (0, _systems.deleteUser)(v.id).then(function (res) {
          if (res.success) {
            _this7.$message({
              type: "success",
              message: "删除成功",
              center: true
            });
            // this.getList();
            _this7.reload();
          } else {
            _this7.$message({
              type: "warning",
              message: res.errorMsg,
              center: true
            });
            _this7.isRepeat = false;
          }
        });
      });
    },
    getRoutes: function (_getRoutes) {
      function getRoutes() {
        return _getRoutes.apply(this, arguments);
      }
      getRoutes.toString = function () {
        return _getRoutes.toString();
      };
      return getRoutes;
    }( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      var res, routes;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getRoutes();
          case 2:
            res = _context.sent;
            this.serviceRoutes = res.data;
            routes = this.generateRoutes(res.data);
            this.routes = this.i18n(routes);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }))),
    // async getRoles() {
    //   const res = await getRoles()
    //   this.rolesList = res.data
    // },
    i18n: function (_i18n) {
      function i18n(_x) {
        return _i18n.apply(this, arguments);
      }
      i18n.toString = function () {
        return _i18n.toString();
      };
      return i18n;
    }(function (routes) {
      var _this8 = this;
      var app = routes.map(function (route) {
        route.title = i18n.t("route.".concat(route.title));
        if (route.children) {
          route.children = _this8.i18n(route.children);
        }
        return route;
      });
      return app;
    }),
    // Reshape the routes structure so that it looks the same as the sidebar
    generateRoutes: function generateRoutes(routes) {
      var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/";
      var res = [];
      var _iterator = (0, _createForOfIteratorHelper2.default)(routes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var route = _step.value;
          // skip some route
          if (route.hidden) {
            continue;
          }
          var onlyOneShowingChild = this.onlyOneShowingChild(route.children, route);
          if (route.children && onlyOneShowingChild && !route.alwaysShow) {
            route = onlyOneShowingChild;
          }
          var data = {
            path: _path.default.resolve(basePath, route.path),
            title: route.meta && route.meta.title
          };

          // recursive child routes
          if (route.children) {
            data.children = this.generateRoutes(route.children, data.path);
          }
          res.push(data);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return res;
    },
    generateArr: function generateArr(routes) {
      var _this9 = this;
      var data = [];
      routes.forEach(function (route) {
        data.push(route);
        if (route.children) {
          var temp = _this9.generateArr(route.children);
          if (temp.length > 0) {
            data = [].concat((0, _toConsumableArray2.default)(data), (0, _toConsumableArray2.default)(temp));
          }
        }
      });
      return data;
    },
    //新增角色
    handleAddRole: function handleAddRole() {
      var _this10 = this;
      // this.role = Object.assign({}, defaultRole);
      // if (this.$refs.tree) {
      //   this.$refs.tree.setCheckedNodes([]);
      // }
      // this.dialogType = "new";
      this.isDisable = false;
      this.dialogVisible = true;
      (0, _systems.queryRole)().then(function (res) {
        _this10.roleList = res.voList;
      });
    },
    handleCheckChange: function handleCheckChange(data) {
      this.arr1 = this.$refs.tree.getCheckedKeys();
      console.log(this.arr1, '898989');
      var a = [];
      this.arr1.map(function (res) {
        if (isNaN(Number(res))) {
          a.push(res);
        }
      });
      this.arr2 = this.$refs.tree.getHalfCheckedKeys();
      console.log(this.arr2, '12313');
      var arr4 = [];
      this.arr2.map(function (res, idx) {
        if (res) {
          if (idx !== 0) {
            arr4.push(res);
          }
        }
      });
      this.addarr = a.concat(arr4);
      // console.log(this.addarr,'新增')
    },
    handleEdit: function handleEdit(scope) {
      // this.dialogType = "edit";
      this.dialogVisible = true;
      // this.checkStrictly = true;
      // this.role = deepClone(scope.row);
      // this.$nextTick(() => {
      //   const routes = this.generateRoutes(this.role.routes);
      //   this.$refs.tree.setCheckedNodes(this.generateArr(routes));
      //   // set checked state of a node not affects its father and child nodes
      //   this.checkStrictly = false;
      // });
    },
    handleDelete: function handleDelete(_ref2) {
      var _this11 = this;
      var $index = _ref2.$index,
        row = _ref2.row;
      this.$confirm("Confirm to remove the role?", "Warning", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning"
      }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return deleteRole(row.key);
            case 2:
              _this11.rolesList.splice($index, 1);
              _this11.$message({
                type: "success",
                message: "Delete succed!"
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    generateTree: function generateTree(routes) {
      var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/";
      var checkedKeys = arguments.length > 2 ? arguments[2] : undefined;
      var res = [];
      var _iterator2 = (0, _createForOfIteratorHelper2.default)(routes),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var route = _step2.value;
          var routePath = _path.default.resolve(basePath, route.path);

          // recursive child routes
          if (route.children) {
            route.children = this.generateTree(route.children, routePath, checkedKeys);
          }
          if (checkedKeys.includes(routePath) || route.children && route.children.length >= 1) {
            res.push(route);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return res;
    },
    confirmRole: function () {
      var _confirmRole = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var _this12 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.role.name == "" || this.role.name == null) {
                this.$message({
                  type: "warning",
                  message: "请填写角色名称",
                  center: true
                });
              } else if (this.role.pid == null || this.role.pid == "") {
                this.$message({
                  type: "warning",
                  message: "请输入所属角色",
                  center: true
                });
              } else if (this.addarr.length == 0) {
                this.$message({
                  type: "warning",
                  message: "请选择权限",
                  center: true
                });
              } else {
                this.isDisable = true;
                this.isRepeat = true;
                (0, _systems.addUser)({
                  idList: this.addarr,
                  name: this.role.name,
                  remark: this.role.remark,
                  pid: this.role.pid
                }).then(function (res) {
                  if (res.success) {
                    _this12.$message({
                      type: "success",
                      message: "添加成功",
                      center: true
                    });
                    _this12.param.roleName = "";
                    _this12.role.name = "";
                    _this12.role.pid = "";
                    _this12.role.remark = "";
                    _this12.dialogVisible = false;
                    _this12.reload();
                    // this.getList();
                  } else {
                    _this12.$message({
                      type: "error",
                      message: res.errorMsg,
                      center: true
                    });
                    _this12.isRepeat = false;
                    _this12.isDisable = false;
                  }
                });
              }

              // const isEdit = this.dialogType === "edit";

              // // const checkedKeys = this.$refs.tree.getCheckedKeys();
              // // this.role.routes = this.generateTree(
              // //   deepClone(this.serviceRoutes),
              // //   "/",
              // //   checkedKeys
              // // );

              // if (isEdit) {
              //   await updateRole(this.role.key, this.role);
              //   for (let index = 0; index < this.rolesList.length; index++) {
              //     if (this.rolesList[index].key === this.role.key) {
              //       this.rolesList.splice(index, 1, Object.assign({}, this.role));
              //       break;
              //     }
              //   }
              // } else {
              //   const { data } = await addRole(this.role);
              //   this.role.key = data.key;
              //   this.rolesList.push(this.role);
              // }

              // const { description, key, name } = this.role;
              // this.dialogVisible = false;
              // this.$notify({
              //   title: "Success",
              //   dangerouslyUseHTMLString: true,
              //   message: `
              //       <div>Role Key: ${key}</div>
              //       <div>Role Nmae: ${name}</div>
              //       <div>Description: ${description}</div>
              //     `,
              //   type: "success"
              // });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function confirmRole() {
        return _confirmRole.apply(this, arguments);
      }
      return confirmRole;
    }(),
    // reference: src/view/layout/components/Sidebar/SidebarItem.vue
    onlyOneShowingChild: function onlyOneShowingChild() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var parent = arguments.length > 1 ? arguments[1] : undefined;
      var onlyOneChild = null;
      var showingChildren = children.filter(function (item) {
        return !item.hidden;
      });

      // When there is only one child route, the child route is displayed by default
      if (showingChildren.length === 1) {
        onlyOneChild = showingChildren[0];
        onlyOneChild.path = _path.default.resolve(parent.path, onlyOneChild.path);
        return onlyOneChild;
      }

      // Show parent if there are no child route to display
      if (showingChildren.length === 0) {
        onlyOneChild = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, parent), {}, {
          path: "",
          noShowingChildren: true
        });
        return onlyOneChild;
      }
      return false;
    }
  }
};